import { Events } from "phaser";

/** emitter for managing external events */
export default new Events.EventEmitter();
